module.exports = __webpack_public_path__ + "hyperion-v2-static/img/PulseAI-info.eff95a1f.png";